<div
  class="fixed inset-0 z-50 flex items-center justify-center p-4 animate-in fade-in duration-200"
  (click)="onBackdropClick()"
>
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

  <!-- Modal -->
  <div
    class="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200"
    (click)="stopPropagation($event)"
  >
    <!-- Header -->
    <div
      class="px-6 py-4 text-white"
      [style.backgroundColor]="themeColor"
    >
      <div class="flex items-start justify-between">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
            <lucide-icon [img]="icons.BookOpen" class="w-5 h-5"></lucide-icon>
          </div>
          <div>
            <h3 class="font-bold text-lg">Standard Details</h3>
            <p class="text-sm opacity-90">{{ data.code }}</p>
          </div>
        </div>
        <button
          type="button"
          class="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
          (click)="onCloseClick()"
        >
          <lucide-icon [img]="icons.X" class="w-4 h-4"></lucide-icon>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="p-6 space-y-4">
      <!-- Standard Text -->
      <div>
        <h4 class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
          Standard Description
        </h4>
        <p class="text-sm text-gray-700 leading-relaxed bg-gray-50 rounded-xl p-4 border border-gray-100">
          {{ data.text }}
        </p>
      </div>

      <!-- Alignment Rationale -->
      @if (data.alignmentRationale) {
        <div>
          <h4 class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-1.5">
            <lucide-icon [img]="icons.Link2" class="w-3.5 h-3.5"></lucide-icon>
            Alignment to "{{ data.criteriaName }}"
          </h4>
          <p class="text-sm text-gray-600 leading-relaxed bg-purple-50 rounded-xl p-4 border border-purple-100">
            {{ data.alignmentRationale }}
          </p>
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 bg-gray-50 border-t border-gray-100">
      <button
        type="button"
        class="w-full py-2.5 px-4 text-white font-medium rounded-xl transition-colors cursor-pointer"
        [style.backgroundColor]="themeColor"
        (click)="onCloseClick()"
      >
        Got it
      </button>
    </div>
  </div>
</div>
